import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './translations/de/translation.json';
import en from './translations/en/translation.json';
import fr from './translations/fr/translation.json';

const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  },
  fr: {
    translation: fr
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: navigator.language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
